import styled from 'styled-components';

import { IUpsellContainer } from './types';

export const UpsellContainer = styled.div<IUpsellContainer>`
  overflow: auto;
  ${p =>
    p.hasBorderAtCheckout &&
    `padding: 1.5rem 2rem 1rem;
     border-radius: ${Styles.borderRadius};
     border: 1px solid ${Styles.color.grey.four};`}
`;

export const UpsellItemButton = styled.button`
  min-width: 250px;
  display: flex;
  flex-direction: row;
  scroll-snap-align: start;
  justify-content: space-between;
  align-items: center;
  background-color: ${Styles.color.white};
  border: 1px solid ${Styles.color.grey.three};
  margin: 4px 10px 4px 4px;
  padding: 20px 15px;
  cursor: pointer;
  font-weight: ${Styles.fontWeight.normal};
  font-family: ${Styles.fontFamily.alternative};
  color: ${Styles.color.secondary};
  line-height: 1.5;
`;

export const UpsellItemIcon = styled.div`
  font-size: 2.5rem;
  padding: 1px 6px;
`;
